import createActionType from "@/redux/utils/createActionType";

export const MODULE = "notifications";

export const SET_NOTIFICATION = createActionType(MODULE, "setNotification");
export const SET_NOTIFICATION_TYPE = createActionType(MODULE, "setNotificationType");
export const SET_LAST_NOTIFICATION = createActionType(MODULE, "setLastNotification");
export const RESET = createActionType(MODULE, "reset");
